import React, { useState } from 'react';
import { colors, radius } from '../../theme';
import { demoSources } from '../../utils/demoMedia';

const Thumbnail = ({ image }) => {
  const { gif, poster } = demoSources(image);
  const [posterFailed, setPosterFailed] = useState(false);
  const [gifFailed, setGifFailed] = useState(false);
  const source = poster && !posterFailed ? poster : gif;
  if (source && !gifFailed) {
    return (
      <img
        src={source}
        alt=""
        onError={() => {
          if (poster && !posterFailed) setPosterFailed(true);
          else setGifFailed(true);
        }}
        style={{ width: '52px', height: '52px', objectFit: 'cover', borderRadius: radius.sm, flexShrink: 0 }}
      />
    );
  }
  return (
    <div style={{
      width: '52px', height: '52px', borderRadius: radius.sm, flexShrink: 0,
      background: colors.surface2, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px',
    }}>
      💪
    </div>
  );
};

/**
 * Compact exercise row with a still poster thumbnail — item 10's "understand the
 * exercise almost instantly" card, sized for pickers/lists rather than
 * the full cinematic hero treatment. Falls back to an icon tile when an
 * exercise has no gif_url, or when the URL fails to load (some exercise
 * GIF links are dead — see GifAudit.jsx, the existing coach tool for
 * catching those at the source).
 */
const ExerciseCard = ({ image, name, subtitle, selected, onClick, disabled, trailing }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 12px',
        marginBottom: '6px',
        background: selected ? colors.successDim : colors.surface1,
        border: `1px solid ${selected ? 'rgba(111,190,142,0.4)' : colors.border}`,
        borderRadius: radius.sm,
        cursor: disabled ? 'not-allowed' : 'pointer',
        textAlign: 'left',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <Thumbnail key={image || ''} image={image} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '14px', fontWeight: 700, color: colors.text }}>{name}</div>
        {subtitle && (
          <div style={{ fontSize: '11px', color: colors.textMuted, marginTop: '2px' }}>{subtitle}</div>
        )}
      </div>
      {trailing}
    </button>
  );
};

export default ExerciseCard;
